 
import $ from 'jquery';
import '../../../jsscripts/jquery/swipe_2.2';
import { tooltip } from '../../smartpak/tooltip';

const ccCompare = {
    _chartOpen: false,
    _calcSwipeWrapWidth: function() {
        var swipeColumnWidth = this._calcColumnWidths(),
            totalColumns = $('.colStrip').length,
            fullWidth = totalColumns * swipeColumnWidth;

        return fullWidth;
    },

    _calcColumnWidths: function() {
        var winWidth = this._getWindowOuterWidth(),
            staticWidth = $('#staticLeftColumn').outerWidth();
        return winWidth - staticWidth;
    },

    _calcTableHeight: function() {
        var $close = $('.closeBar'),
            closeHeight = $close.length ? $close.outerHeight() : 0;
        return window.innerHeight - closeHeight;
    },

    _getStyleValue: function($element, style) {
        return Number($element.css(style).replace('px', ''));
    },

    _calcStyleOffset: function() {
        var $vertCell = $('.vertCell'),
            padTop = this._getStyleValue($vertCell, 'padding-top'),
            padBot = this._getStyleValue($vertCell, 'padding-bottom'),
            border = this._getStyleValue($vertCell, 'border-bottom-width');
        return padTop + padBot + border;
    },

    _calcRowHeights: function() {
        var styleOffset = this._calcStyleOffset(),
            rows = $('#staticLeftColumn').children().length,
            rowHeight = this._calcTableHeight() / (rows + 2) - styleOffset;

        return rowHeight;
    },

    _centerLabels: function() {
        var $parentCell = $('.vertCell');
        $('.prodHeadCell').css({width: $parentCell.width(), height: $parentCell.height()});
    },

    _sizeHeadImage: function() {
        var screenHeight = screen.height,
            iPhone4Height = 481,
            iPhone5Height = 569;
        if (screenHeight < iPhone4Height) {
            return '0%';
        } else if (screenHeight < iPhone5Height) {
            return '33%';
        }
        return '55%';
    },

    _doiPhone4Sizing: function() {
        if (screen.height > 480) {
            return;
        }
        var $headCell = $('.columnHeadCell'),
            $vertCell = $('.vertCell'),
            headCellHeight = $headCell.height(),
            vertCellHeight = $vertCell.height();

        $('.prodHeadImage').remove();
        $headCell.css({'max-height': headCellHeight - 24 + 'px', 'min-height': headCellHeight - 24 + 'px'});
        $vertCell.css({'max-height': vertCellHeight + 4 + 'px', 'min-height': vertCellHeight + 4 + 'px'});
        $('#chartTitle').css('bottom', '0px');
        $('.prodHeadContent').css('bottom', '7px');
        $('.prodHeadLink').css({'line-height': '18px'});
        $('.prodHeadCell').css('font-size', '13px');
    },

    initChart: function() {
        var cellHeight = this._calcRowHeights(),
            headHeight = cellHeight * 3;
        $('#tableWrapper').height(this._calcTableHeight());
        $('.vertCell').css({'max-height': cellHeight + 'px', 'min-height': cellHeight + 'px'});
        $('.columnHeadCell').css({'max-height': headHeight + 'px', 'min-height': headHeight + 'px'});
        $('.prodHeadImage').css('width', this._sizeHeadImage());
        $('.colStrip').width(this._calcColumnWidths());
        $('.swipe-wrap').width(this._calcSwipeWrapWidth());
        this._doiPhone4Sizing();
        this._centerLabels();
        
        new window.Swipe(document.getElementById('slider'), {continuous: false});
    },

    _showChart: function() {
        smartPak.ui.modal($('#chartWrapper').get(0));
        $('body').css('overflow', 'hidden');
    },

    _bindChartOpen: function() {
        $('.ccChartLaunch').on('click', this._showChart);
    },

    // ORIENTATION

    _initHandleOrientation: function() {
        setTimeout(this._handleOrientationChange, 200);
    },

    _handleOrientationChange: function() {
        var oriented = window.matchMedia('(orientation: portrait)'),
            hider = () => {
                $('#compareLaunchBar').show();
                if (this._chartOpen) {
                    this._hideOrientationWarning();
                }
            },
            shower = () => {
                $('#compareLaunchBar').hide();
                if (this._chartOpen) {
                    this._showOrientationWarning();
                }
            };

        if (!oriented.matches) {
            shower();
        } else {
            hider();
        }
    },

    _showOrientationWarning: function() {
        if ($('#landscapeWarning').length) {
            return;
        }
        var screenHeight = window.innerHeight,
            screenWidth = window.innerWidth;
        $(
            '<div id="landscapeWarning" style="height:' +
                screenHeight +
                '; width:' +
                screenWidth +
                '">This feature is only available in portrait view.<br>Please rotate your device<img id="rotateIcon" src="/images/mobile/rotate.png" /></div>'
        ).insertBefore('.closeBar');
    },

    _hideOrientationWarning: function() {
        this.initChart();
        $('#landscapeWarning').remove();
    },

    // INSTRUCTIONAL TOOLTIP

    _showInstructionsToolTip: function() {
        if (sessionStorage.ccChartTipDisplayed === 'true') {
            return;
        }

        var $ttElement = $('#chartInstructions').length
            ? $('#chartInstructions')
            : $(
                    "<a href='#' class='tooltipTrigger jsHide' id='chartInstructions' title='Simply swipe the right column left or right to compare ColiCare supplements ingredient by ingredient.'></a>"
                ).appendTo('body');
        
        $('.mobileModal').css('z-index', '90');

        tooltip([$ttElement.get(0)]);

        $ttElement.trigger('click');

        sessionStorage.ccChartTipDisplayed = true;
    },

    _doAfterOpen: function() {
        this._chartOpen = true;
        this._handleOrientationChange();
        this._showInstructionsToolTip();
        this.initChart();
    },

    // for jasmine testing:

    _getChartOpenValue: function() {
        return this._chartOpen;
    },

    _getWindowOuterWidth: function() {
        return window.outerWidth;
    },

    // INITIALIZE

    init: function() {
        var $win = $(window);
        this._bindChartOpen();
        $win.on('orientationchange', this._initHandleOrientation); // add 'resize' event to test in emulator //
        $win.trigger('orientationchange');
    }
};

export default ccCompare;